import React from "react";
import { SocialIcon } from "react-social-icons";

const Socials = () => {
  return (
    <div className="socials">
      <SocialIcon
        className="social-icon"
        url="https://soundcloud.com/rehearsalnotice"
      />
      <SocialIcon
        className="social-icon"
        url="https://www.instagram.com/rehearsalnotice"
      />
      <SocialIcon
        className="social-icon"
        url="https://www.tiktok.com/@rehearsalnotice"
      />
      <SocialIcon
        className="social-icon"
        url="https://www.youtube.com/@rehearsalnotice"
      />
      <SocialIcon
        className="social-icon"
        url="https://twitter.com/rehearsalnotice"
      />
      <SocialIcon
        className="social-icon"
        url="https://linktr.ee/rehearsalnotice"
      />
    </div>
  );
};

export default Socials;
